export default "__VITE_ASSET__850cbeb5__"